import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import {
  CenteredContainer,
  Text,
  Link,
  Type,
  Stack,
} from '@nerdwallet/currency';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';

const CCBest = ({ eyebrow, heading, links }) => {
  return (
    <BedrockImpression entityName="best_card_category_tool">
      <ElementImpression
        elementDomType="section"
        elementName="CCBest"
        id="best-cards-tool"
      >
        <CenteredContainer
          className={classNames([
            'cc-best__section',
            classes('margin-bottom-5'),
            classes('padding-horizontal-4--wide'),
          ])}
        >
          <div
            className={classNames([
              'cc-best__content',
              classes('border-neutral-lighter'),
              classes('border-all-1'),
              classes('padding-vertical-4'),
              classes('padding-horizontal-4'),
              classes('display-flex'),
              classes('flex-direction-column'),
              classes('flex-direction-row--wide'),
            ])}
          >
            <div
              className={classNames([
                'cc-best-section__text',
                classes('margin-horizontal-auto'),
                classes('text-align-center'),
                classes('width-100'),
              ])}
            >
              <Type
                color="neutral-darker"
                uppercase
                size={1}
                bold
                className={classNames([
                  'cc-best-section__eyebrow',
                  classes('margin-bottom-3'),
                ])}
              >
                {eyebrow}
              </Type>
              <div
                className={classNames([
                  'cc-best-section__heading',
                  classes('margin-bottom-3'),
                ])}
              >
                <Text size="large" bold component="h2">
                  {heading}
                </Text>
              </div>
              <div
                className={classNames([
                  'cc-best-section__links',
                  classes('display-none'),
                  classes('display-block--wide'),
                ])}
              >
                ⚖ <Link href={links.balanceLink}>Balance Transfer</Link> | 🙌{' '}
                <Link href={links.lowInterestLink}>Low interest</Link> | 🏖{' '}
                <Link href={links.travelLink}>Travel</Link> | 💰{' '}
                <Link href={links.cashBackLink}>Cash back</Link> | 🎁{' '}
                <Link href={links.rewardsLink}>Rewards</Link>
              </div>
              <div
                className={classNames([
                  'cc-best-section__linksMobile',
                  classes('display-block'),
                  classes('display-none--wide'),
                ])}
              >
                <Stack spacing="3">
                  <div>
                    ⚖ <Link href={links.balanceLink}>Balance Transfer</Link>
                  </div>
                  <div>
                    🙌 <Link href={links.lowInterestLink}>Low interest</Link>
                  </div>
                  <div>
                    🏖 <Link href={links.travelLink}>Travel</Link>
                  </div>
                  <div>
                    💰 <Link href={links.cashBackLink}>Cash back</Link>
                  </div>
                  <div>
                    🎁 <Link href={links.rewardsLink}>Rewards</Link>
                  </div>
                </Stack>
              </div>
            </div>
          </div>
        </CenteredContainer>
      </ElementImpression>
    </BedrockImpression>
  );
};

CCBest.propTypes = {
  eyebrow: PropTypes.string,
  heading: PropTypes.string,
  links: PropTypes.object,
};

CCBest.displayName = 'CCBest';

export default CCBest;
